import { Component, OnInit, AfterViewInit, Injector } from '@angular/core';
import { ChartQuotePanel } from '../chart.quotepanel/chart.quotepanel.component';
import { RangeButtonService } from '../../services/rangeButtonService/rangeButtonService.service';

@Component({
  selector: 'app-mobile-chartquotepanel',
  template: require('./mobile-chart.quotepanel.component.html'),
  styles: [require('./mobile-chart.quotepanel.component.scss')]
})
export class MobileChartQuotepanelComponent extends ChartQuotePanel  implements AfterViewInit {

  constructor(injector: Injector,  rangeButtonService: RangeButtonService) {

    super(injector, rangeButtonService);
   }

  ngOnInit() {}
  ngAfterViewInit(){}
}
